import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PaySlipSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/payroll/_layout/pay-slips/')({
  validateSearch: zodValidator(PaySlipSearchSchema)
});